/**
 * The Lookout compute warehouse field (ACT2-1031), shared by every form that takes one: the Snowflake
 * add-account form, the RudderStack-key setup step and the account-view editor. Kept out of the
 * component files so React fast refresh keeps working on them.
 */
import { z } from 'zod';

import { SNOWFLAKE_IDENTIFIER_MAX_LENGTH } from '../../../lib/snowflake-setup';

export const LOOKOUT_WAREHOUSE_HINT = 'Fill this in only if you want Lookout to use a separate warehouse.';

/**
 * An optional Lookout compute warehouse name, shared by every form that takes one. Only the length is
 * checked here: a quoted name is a valid warehouse, and the managed-key form adds the setup SQL's own
 * name rule where the script has to carry it.
 */
export const optionalWarehouseNameSchema = z
  .string()
  .max(SNOWFLAKE_IDENTIFIER_MAX_LENGTH, 'Warehouse name is too long');
